import React, { useContext, useRef } from 'react'
import styles from './ExperienceYears.module.css'
import { ChoicesButton } from '../../../Common/CtaButton/ChoicesButton'
import { BackButton } from '../../../Common/CtaButton/BackButton'
import { StepContext } from '@/components/Context/StepContext'
import { useAbTestGtm } from '@/components/utils/abTest'
import { FollowIcon } from '../../../FormGuidance/FollowIcon'
import { useFollowIcon } from '../../../FormGuidance/FollowIcon/useFollowIcon'

export const ExperienceYears = ({ gtmTags }) => {
    const { handleNext, handlePrev, updateFormData, formData, isCurrentStepValid, isAnimating, currentStep } = useContext(StepContext)

    const parentRef = useRef<HTMLDivElement>(null)
    const questionRef = useRef<HTMLDivElement>(null)
    const selectionRef = useRef<HTMLDivElement>(null)
    const targets = [
        { ref: questionRef, isComplete: false },
        { ref: selectionRef, isComplete: isCurrentStepValid },
    ]
    const { iconStyle } = useFollowIcon({ parentRef, targets, isAnimating, layoutKey: currentStep })

    const handleSelect = (years) => {
        updateFormData('experienceYears', years)
        handleNext()
    }

    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.wrapper} ref={parentRef} data-view-label={dataViewLabel(gtmTags.dataViewLabel)}>
            <FollowIcon iconStyle={iconStyle} />
            <div className={styles.title} ref={questionRef}>
                <BackButton
                    dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.back)}
                    onClick={handlePrev}
                />
                <h2
                    className={styles.titleText}
                >
                    Q.業界の経験年数は何年ですか？
                </h2>
            </div>
            <div className={styles.selectionWrapper} ref={selectionRef}>
                <ChoicesButton
                    imageSrc='/entry_form_slide_app/steps/step2/one-year.png'
                    imageAlt='1年未満'
                    dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.lessThan1)}
                    onClick={() => handleSelect('1年未満')}
                    selected={formData.experienceYears === '1年未満'}
                />
                <ChoicesButton
                    imageSrc='/entry_form_slide_app/steps/step2/five-year.png'
                    imageAlt='1~5年'
                    dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.oneToFive)}
                    onClick={() => handleSelect('1~5年')}
                    selected={formData.experienceYears === '1~5年'}
                />
                <ChoicesButton
                    imageSrc='/entry_form_slide_app/steps/step2/ten-year.png'
                    imageAlt='5~10年'
                    dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.fiveToTen)}
                    onClick={() => handleSelect('5~10年')}
                    selected={formData.experienceYears === '5~10年'}
                />
                <ChoicesButton
                    imageSrc='/entry_form_slide_app/steps/step2/more-ten-year.png'
                    imageAlt='10年以上'
                    dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.moreThan10)}
                    onClick={() => handleSelect('10年以上')}
                    selected={formData.experienceYears === '10年以上'}
                />
            </div>
        </div>
    )
}
